import React from "react";
import PlaceholderPage from "./PlaceholderPage";

export const DeskPage = () => (
  <PlaceholderPage
    eyebrow="The Desk"
    title="Vexent Wire Desk"
    body={
      <>
        <p>
          The Desk is where Vexent Wire editorial appears under the byline
          of the analyst who wrote it — with cover of their coverage focus,
          publication history, and a direct feed of every note they've filed.
        </p>
        <p>
          Contributor profiles are staged for launch. Each analyst will have a
          dedicated page, biography, focus areas, and searchable archive of
          research and commentary.
        </p>
      </>
    }
    actionLabel="View Recent Research"
    actionHref="/"
    testid="desk-page"
  />
);

export default DeskPage;
